import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlComponent, DynamicFormControlCustomEvent, DynamicFormLayoutService, DynamicFormValidationService } from '@ng-dynamic-forms/core';
import { PageBuilderTextareaModel } from './page-builder-textarea.model';

@Component({
  selector: 'dynamic-page-builder-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dynamic-page-builder-textarea.component.html'
})
export class DynamicPageBuilderTextareaComponent extends DynamicFormControlComponent {
  @Input() bindId = true;
  @Input() group: FormGroup;
  @Input() model: PageBuilderTextareaModel;
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() customEvent: EventEmitter<DynamicFormControlCustomEvent> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  constructor(protected layoutService: DynamicFormLayoutService, protected validationService: DynamicFormValidationService) {
    super(layoutService, validationService);
  }
}
